const STORAGE_KEY = "photox.pending-event-access";
const CONTEXT_TTL_MS = 30 * 60 * 1000;
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

export function isValidQrToken(token) {
  return TOKEN_PATTERN.test(token || "");
}

export function readPendingQrContext(storage = window.sessionStorage, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(STORAGE_KEY) || "null");
    if (!isValidQrToken(value?.token) || value.expiresAt <= now) {
      storage.removeItem(STORAGE_KEY);
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

export function clearPendingQrContext(storage = window.sessionStorage) {
  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    // The in-memory React state still supports the current tab when storage is unavailable.
  }
}

export function capturePendingQrContext({
  location = window.location,
  history = window.history,
  storage = window.sessionStorage,
  now = Date.now()
} = {}) {
  const params = new URLSearchParams(location.search);
  const scannedToken = params.get("token");
  if (scannedToken !== null) {
    params.delete("token");
    const query = params.toString();
    // Legacy QR links are issued as /?token=... . Move them to the
    // canonical Guest path before removing the sensitive token. Otherwise a
    // refresh after OTP could show the public homepage instead of the event.
    const path = location.pathname === "/" || location.pathname === "/index.html"
      ? "/events/join"
      : location.pathname;
    history.replaceState(history.state || {}, "", `${path}${query ? `?${query}` : ""}${location.hash || ""}`);
    if (!isValidQrToken(scannedToken)) {
      clearPendingQrContext(storage);
      return { token: "", error: "This QR code is malformed or incomplete." };
    }
    const context = { token: scannedToken, expiresAt: now + CONTEXT_TTL_MS };
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(context));
    } catch {
      // Keep the context in React state for this tab when storage is unavailable.
    }
    return context;
  }
  return readPendingQrContext(storage, now) || { token: "", expiresAt: 0 };
}

export { CONTEXT_TTL_MS, STORAGE_KEY };
